{
  "edit-association-for": "Editar asociación del partido a",
  "add-new-party-for": "Añadir partido a",
  "percent": "Porcentaje",
  "before-closing-amount": "Monto antes del Cierre",
  "before-closing-percent": "Porcentaje antes del Cierre",
  "at-closing-amount": "Monto al Cierre",
  "at-closing-percent": "Porcentaje al Cierre",
  "payment-id": "ID del metodo de pago",
  "cant-get-info": "No podemos obtener informacion acerca de los metodos de pago del contacto",
  "edit-association": "Editar Asociacion",
  "add-association": "Agregar Asociacion",
  "accounting": "Contabilidad",
  "receipts": "Recibos",
  "disbursements": "Desembolsos",
  "basic": "Basico",
  "manual": "Manual",
  "endorsements": "Endosos",
  "ledger": "Libro",
  "money-flow": "Flujo de Dinero",
  "money-flow-short": "Flujo",
  "no-money-flow": "No hay flujo de dinero que mostrar para esta orden.",
  "view-full-diagram": "Ver diagrama completo",
  "others": "Otros",
  "other-parties": "Otras partes",
  "void-ledger": "En este momento no tenemos información contable, por favor complete los módulos requeridos",
  "amount-override": "Monto Sobreescrito",
  "dislosed-as": "Divulgado Como",
  "months": "Meses",
  "letter": "Letra",
  "amount": "Monto",
  "description": "Descripción",
  "code": "Código",
  "kind": "Tipo",
  "entry-date": "Fecha de Entrada",
  "edit-entry": "Editar Entrada",
  "add-entry": "Agregar Entrada",
  "parties": "Partidas",
  "full-amount": "Monto Completo",
  "reset-value": "Reiniciar Valor",
  "reset": "Restablecer",
  "name": "Nombre",
  "actions": "Acciones",
  "holder": "Poseedor",
  "accounting-totals": "Totales contables",
  "total-receipts": "Recibos totales",
  "all-disbursements": "Todos los desembolsos",
  "underfunded": "Fondos insuficientes",
  "overfunded": "Sobrefinanciado",
  "balancing": "Equilibrio contable",
  "posted-receipts": "Recibos publicados",
  "expected-receipts": "Recibos esperados",
  "posted-disbursements": "Desembolsos publicados",
  "expected-disbursements": "Desembolsos Esperados",
  "lender-owes": "El prestamista debe",
  "borrower-owes": "El prestatario debe",
  "earnest-owed": "Seña Adeudada",
  "seller-due": "Adeudado al Vendedor",
  "others-due": "Otros débitos",
  "balanced": "Balance",
  "payment-method": "Metodo de Pago",
  "number": "Numero",
  "accounted-for": "Contabilizado Por",
  "add-document-entry": "Agregar documento",
  "add-payment": "Agregar pago",
  "annuality": "Anualidad",
  "request-revision": "Solicitar Revision",
  "success-revision": "La solicitud para revisar el libro mayor de pedidos se envió con éxito",
  "error-revision": "Se produjo un error al procesar su solicitud para revisar el libro mayor de pedidos. Por favor, inténtelo más tarde.",
  "posted": "Contabilizado",
  "true": "Verdadero",
  "false": "Falso",
  "faked": "Manipulado",
  "overridden": "Reemplazado",
  "edit-ledger-entry": "Editar Entrada del Libro Mayor",
  "add-new-ledger-entry": "Agregar Entrada del Libro Mayor",
  "cash": "Efectivo",
  "check": "Cheque",
  "wire": "Transferencia",
  "loan-amount": "Monto del Préstamo",
  "purchase-price": "Precio de Compra",
  "accountedBy": "Contabilizado Por",
  "totalAmountAccounted": "{{amount}} (Monto Total Contabilizado)",
  "accountedEntry": "{{amount}} ({{description}})",
  "disbursementsLedger": "Desembolsos - Libro Mayor",
  "editLedgerEntry": "Editar Entrada del Libro Mayor",
  "escrowAccount": "Cuenta de Depósito en Garantía {{number}}",
  "transferAccount": "Cuenta de Transferencia {{number}}",
  "fields:amount": "Monto",
  "fields:code": "Código",
  "fields:description": "Descripción",
  "fields:kind": "Tipo",
  "fields:entryDate": "Fecha de Entrada",
  "fields:letter": "Letra",
  "fields:number": "Número",
  "fields:months": "Meses totales",
  "fields:months_advanced": "Meses pagados por adelantado",
   "fields:annuality": "Anualidad",
   "fields:percent": "Porcentaje",
   "fields:associationPercent": "Porcentaje",
  "fields:associationAmount": "Monto",
  "fields:associationKind": "Tipo",
  "fields:partyName": "Nombre de la Parte",
  "fields:partyEmail": "Correo Electrónico",
  "fields:partyKind": "Tipo de Parte",
  "fields:linkedEntryId": "Entrada Vinculada",
  "fields:linkedAmount": "Monto Vinculado",
  "fields:posted": "Contabilizado",
  "fields:faked": "Manipulado",
  "fields:overridden": "Reemplazado",
  "tabs:entry": "Entrada",
  "tabs:association": "Asociación",
  "tabs:party": "Parte",
  "tabs:link": "Vínculo",
  "tabs:settings": "Configuración",
  "confirmDialog:deleteTitle": "Confirmar Eliminar",
  "confirmDialog:deleteMessage": "Esta acción no se puede deshacer.",
  "submitState:partialSuccess": "Éxito Parcial",
  "submitState:partialSuccessMessage": "Algunas operaciones tuvieron éxito, pero otras fallaron.",
  "submitState:error": "Error",
  "validation:required": "Este campo es obligatorio",
  "validation:invalidAmount": "Monto inválido",
  "validation:invalidDate": "Fecha inválida. Use el formato MM/DD/YYYY.",
  "validation:invalidPercent": "Porcentaje inválido",
  "no-manual-entries": "Sin Entradas Manuales",
  "no-manual-entries-description": "No hay entradas manuales en esta orden.",
  "manual-entries-test": "Entradas Manuales (Prueba)",
  "manual-entries-test-description": "Seleccione una entrada para abrir el modal del editor.",
  "common:processing": "Procesando...",
  "common:retry": "Reintentar",
  "common:select": "Seleccionar...",
  "common:cancel": "Cancelar",
  "common:save": "Guardar",
  "common:saving": "Guardando...",
  "common:delete": "Eliminar",
  "errors:generic": "Algo salió mal",
  "errors:unknownEntry": "Entrada desconocida",
  "errors:invalidDate": "Fecha inválida",
  "errors:linkedAmountExceeded": "Monto vinculado excedido",
  "errors:accountedAssociation": "Asociación contabilizada",
  "errors:networkError": "Error de red. Por favor, verifique su conexión e intente de nuevo.",
  "errors:retryFailed": "Reintento fallido. Por favor, intente más tarde.",
   "submitState:loading": "Cargando...",
   "submitState:retrying": "Reintentando...",
   "config-selector": "Configuración",
   "select-all": "Seleccionar Todo",
   "clear-all": "Borrar Todo",
   "enable-delete": "Habilitar Eliminar",
   "enable-posted": "Habilitar Contabilizado",
   "require-description": "Requerir Descripción",
   "common:error": "Error",
   "common:no-description": "Sin descripción",
   "errors:unknown": "Se produjo un error desconocido.",
   "flags": "Banderas"
}
